<div class="sidenav-content" cdkScrollable *ngIf="!isLoading else spinner">
	<copo-panel-header [isBackButtonVisible]="true" (backButtonClick)="goBack()" [titleHeaderText]="('auction.selection'|translate)+' - '+('auction.bidding'|translate)+' '+auctionOffer.name+' - '+('add-suborg.confirmation'|translate)">
		<button mat-flat-button type="button" color="primary" [disabled]="isConfirmDisabled" (click)="confirmBid($event)">
			<span translate>auction.confirm.bid</span>
		</button>
	</copo-panel-header>
		<copo-legal-document-agreement [legalDocumentLabel]="auctionLabelValue" [serviceCode]="auctionServiceCode"
			(userAgreementCheck)="onUserAgreementCheck($event)"></copo-legal-document-agreement>
	<div *ngIf="!isUserAgreementsLoading else loading" class="offer-details-block">
		<div class="offer-details-block-item">
			<div class="copo-form-container">
				<copo-stepper class="copo-stepper-container" [steps]="steps" (stepClicked)="onStepClicked($event)"></copo-stepper>
				<button type="button" mat-icon-button (click)="print()" class="print-button">
					<mat-icon svgIcon="md:print" class="print-icon"></mat-icon>
				</button>
			</div>
			<div class="copo-section-header" translate>auction.description</div>
			<div class="card-info-block">
				<div class="card-content-block triple-column">
					<div class="card-contents-infos">
						<div class="card-content-info">
							<div class="card-content-label" translate>guarantee.customer.name</div>
							<div class="card-content-value">{{ soldToName }}</div>
						</div>
						<div class="card-content-info">
							<div class="card-content-label" translate>offers.create.details.field.offer-name</div>
							<div class="card-content-value">{{ auctionOffer.name ? auctionOffer.name : UNDERSCORE}}</div>
						</div>
						<div class="card-content-info">
							<div class="card-content-label" translate>start.date</div>
							<div class="card-content-value">{{ auctionOffer.startDate ? (auctionOffer.startDate | copoDate:'datetime') : UNDERSCORE }}</div>
						</div>
						<div class="card-content-info">
							<div class="card-content-label" translate>auction.offer.payment.condition</div>
							<div class="card-content-value field-overflow">{{ auctionOffer.paymentTerm ? auctionOffer.paymentTerm : UNDERSCORE}}</div>
						</div>
					</div>
					<div class="card-contents-infos">
						<div class="card-content-info">
							<div class="card-content-label" translate>auction.mill</div>
							<div class="card-content-value">{{ auctionOffer.mill ? auctionOffer.mill.name : UNDERSCORE }}</div>
						</div>
						<div class="card-content-info">
							<div class="card-content-label" translate>end.date</div>
							<div class="card-content-value">{{ auctionOffer.endDate ? (auctionOffer.endDate | copoDate:'datetime') : UNDERSCORE }}</div>
						</div>
						<div class="card-content-info">
							<div class="card-content-label" translate>auction.offer.invoicing.in</div>
							<div class="card-content-value">{{ auctionOffer.invoicingUnit ? auctionOffer.invoicingUnit : UNDERSCORE}}</div>
						</div>
					</div>
					<div class="card-contents-infos">
						<div class="card-content-info">
							<div class="card-content-label" translate>auction.market</div>
							<div class="card-content-value">{{ auctionOffer.market ? auctionOffer.market : UNDERSCORE}}</div>
						</div>
						<div class="card-content-info">
							<div class="card-content-label" translate>auction.offer.lanned.loading.date</div>
							<div class="card-content-value">{{ auctionOffer.plannedLoadingDate ? (auctionOffer.plannedLoadingDate | copoDate:'date') : UNDERSCORE }}</div>
						</div>
						<div class="card-content-info">
							<div class="card-content-label" translate>auction.offer.transport.invoiced.conditions</div>
							<div class="card-content-value">{{ auctionOffer.transportInvoicingCondition ? auctionOffer.transportInvoicingCondition : UNDERSCORE}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<ng-container *ngFor=" let bundle of auctionOffer.bundles; let i = index ;">
			<div class="bundle-list-block request-block-normal" #bundleDiv>
				<div class="bundle-list-block-item" *ngIf="hasCustomerPlacedBidOnBundle(bundle)">
					<div class="bundle-list-block-row1"> 
						<div class="bundle-content-info">
							<div class="bundle-heading" translate>auction.offer.bundle</div>
							<div class="bundle-name">{{ bundle.name }}</div>
						</div>
						<div class="bundle-content-info">
							<div class="card-content-label" translate>datacenter-filter.delivery-address</div>
							<div class="card-content-value">{{ bidsMap.get(i)?.shipTo?.name || UNDERSCORE }}</div>
						</div>
						<div class="bundle-content-info">
							<div class="card-content-label" translate>commercial-documents.transport-mode</div>
							<div class="card-content-value">{{ getTransportMode(bidsMap.get(i)?.transportModeDescription) ? (getTransportMode(bidsMap.get(i)?.transportModeDescription)! | translate) : UNDERSCORE }}</div>
						</div>
						<div class="bundle-content-info" *ngIf="!bidsMap.get(i)?.incoterm2 ">
							<div class="card-content-label" translate>order.incoterm</div>
							<div class="card-content-value">{{ bidsMap.get(i)?.incoterm ? ( 'incoterm.'+ bidsMap.get(i)?.incoterm | translate) : UNDERSCORE }}</div>
						</div>
						<div class="bundle-content-info" *ngIf="bidsMap.get(i)?.incoterm2 ">
							<div class="card-content-label">
								<span translate>order.incoterm</span>
								<span>{{ '('+('order.incoterm2' | translate)+')' }}</span>
							</div>
							<div class="card-content-value">
								<span>{{ bidsMap.get(i)?.incoterm ? ( 'incoterm.'+ bidsMap.get(i)?.incoterm | translate) : UNDERSCORE }}</span>
								<span>{{ bidsMap.get(i)?.incoterm2 ? ( '('+ bidsMap.get(i)?.incoterm2+')') : UNDERSCORE }}</span>
							</div>
						</div>
					</div>
					<div class="bundle-list-block-row2">
						<div class="pill request-block-status">
							<div class="request-block-status-label">
								<span>{{ bundle.weight | copoNumber:'weight':(unitBatchOptions['to'].symbol )}}</span>
								<span>&nbsp;{{ UNDERSCORE }}&nbsp;</span>
								<span translate>auction.weight.unit.gross</span>
							</div>
						</div>
						<div class="bundle-content-info">
							<div class="card-content-label" translate>auction.offer.customer.reference</div>
							<div class="card-content-value">{{ bidsMap.get(i)?.customerReference || UNDERSCORE }}</div>
						</div>
						<div class="bundle-content-info">
							<div class="card-content-label" translate>auction.offer.exw.price</div>
							<div class="card-content-value">{{ bidsMap.get(i)?.price? (((bidsMap.get(i)?.price | copoNumber: 'amount')+('auction.price.unit.et' | translate))) : UNDERSCORE }}</div>
						</div>
						<div class="bundle-content-info">
							<div class="card-content-label" translate>auction.offer.transport.cost</div>
							<div class="card-content-value">{{ bidsMap.get(i)?.transportPrice? ((bidsMap.get(i)?.transportPrice | copoNumber: 'amount')+('auction.price.unit.et' | translate)) : UNDERSCORE }}</div>
						</div>
						<div class="bundle-content-info">
							<div class="card-content-label" translate>auction.offer.effective.price</div>
							<div class="card-content-value">{{ (((calculateEffectivePrice(bidsMap.get(i)?.price, bidsMap.get(i)?.transportPrice) | copoNumber: 'amount')+('auction.price.unit.et' | translate))) || UNDERSCORE }}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="bundle-list-block request-block-small">
				<div class="bundle-list-block-item" *ngIf="hasCustomerPlacedBidOnBundle(bundle)">
					<div class="bundle-list-block-row1"> 
						<div class="bundle-content-info">
							<div class="bundle-heading" translate>auction.offer.bundle</div>
						</div>
						<div class="bundle-name">{{ bundle.name }}</div>
						<div class="pill request-block-status">
							<div class="request-block-status-label">
								<span>{{ bundle.weight |copoNumber:'weight':(unitBatchOptions['to'].symbol )}}</span>
								<span>&nbsp;{{ UNDERSCORE }}&nbsp;</span>
								<span translate>auction.weight.unit.gross</span>
							</div>
						</div>
					</div>
					<div class="bundle-list-block-row2">
						<div class="bundle-content-info">
							<div class="card-content-label" translate>datacenter-filter.delivery-address</div>
							<div class="card-content-value">{{ bidsMap.get(i)?.shipTo?.name || UNDERSCORE }}</div>
						</div>
						<div class="bundle-content-info">
							<div class="card-content-label" translate>commercial-documents.transport-mode</div>
							<div class="card-content-value">{{ getTransportMode(bidsMap.get(i)?.transportModeDescription) ? (getTransportMode(bidsMap.get(i)?.transportModeDescription)! | translate) : UNDERSCORE }}</div>
						</div>
						<div class="bundle-content-info" *ngIf="!bidsMap.get(i)?.incoterm2 ">
							<div class="card-content-label" translate>order.incoterm</div>
							<div class="card-content-value">{{ bidsMap.get(i)?.incoterm ? ( 'incoterm.'+ bidsMap.get(i)?.incoterm | translate) : UNDERSCORE }}</div>
						</div>
						<div class="bundle-content-info" *ngIf="bidsMap.get(i)?.incoterm2 ">
							<div class="card-content-label">
								<span translate>order.incoterm</span>
								<span>{{ '('+('order.incoterm2' | translate)+')' }}</span>
							</div>
							<div class="card-content-value">
								<span>{{ bidsMap.get(i)?.incoterm ? ( 'incoterm.'+ bidsMap.get(i)?.incoterm | translate) : UNDERSCORE }}</span>
								<span>{{ bidsMap.get(i)?.incoterm2 ? ( '('+ bidsMap.get(i)?.incoterm2+')') : UNDERSCORE }}</span>
							</div>
						</div>
						<div class="bundle-content-info">
							<div class="card-content-label" translate>auction.offer.customer.reference</div>
							<div class="card-content-value">{{ bidsMap.get(i)?.customerReference || UNDERSCORE }}</div>
						</div>
						<div class="bundle-content-info">
							<div class="card-content-label" translate>auction.offer.exw.price</div>
							<div class="card-content-value">{{ bidsMap.get(i)?.price? (((bidsMap.get(i)?.price | copoNumber: 'amount')+('auction.price.unit.et' | translate))) : UNDERSCORE }}</div>
						</div>
						<div class="bundle-content-info">
							<div class="card-content-label" translate>auction.offer.transport.cost</div>
							<div class="card-content-value">{{ bidsMap.get(i)?.transportPrice? ((bidsMap.get(i)?.transportPrice | copoNumber: 'amount')+('auction.price.unit.et' | translate)) : UNDERSCORE }}</div>
						</div>
						<div class="bundle-content-info">
							<div class="card-content-label" translate>auction.offer.effective.price</div>
							<div class="card-content-value">{{ (((calculateEffectivePrice(bidsMap.get(i)?.price, bidsMap.get(i)?.transportPrice) | copoNumber: 'amount')+('auction.price.unit.et' | translate))) || UNDERSCORE }}</div>
						</div>
					</div>
				</div>
			</div>
		</ng-container>
	</div>
	<ng-template #loading>
		<copo-loading-spinner class="loading-spinner-container-padded"></copo-loading-spinner>
	</ng-template>
</div>
<ng-template #spinner>
	<copo-loading-spinner class="loading-spinner-container-padded"></copo-loading-spinner>
</ng-template>